import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import SearchBar from '@/components/SearchV3/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import DialogForm from '@/components/DialogForm/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import { appSource } from '@/common/material-metadata';
import { fetchAppInfoList, updateAppInfo, syncAppInfo } from '@/api/system/app';

export default {
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    DialogForm: DialogForm,
    TableList: TableList
  },
  mixins: [searchMixin],
  data: function data() {
    var keyworkList = [{
      value: 'name',
      label: '应用名称'
    }, {
      value: 'id',
      label: '应用ID'
    }, {
      value: 'package_name',
      label: '应用包名'
    }];
    return {
      query: {
        page: 1,
        page_size: 15,
        platform: '',
        source: '',
        search_field: 'name',
        keyword: ''
      },
      pagination: {
        total: 0
      },
      formItemList: [{
        type: 'business',
        subtype: 'platform-selector',
        prop: 'platform'
      }, {
        prop: 'source',
        type: 'select',
        params: {
          clearable: true,
          placeholder: '请选择来源',
          options: appSource
        }
      }, {
        prop: 'search_field',
        type: 'select',
        params: {
          clearable: true,
          options: keyworkList,
          placeholder: '请选择搜索类型'
        }
      }, {
        prop: 'keyword',
        type: 'input',
        params: function params(_ref) {
          var formValue = _ref.formValue;

          return {
            disabled: false,
            readonly: false,
            clearable: true,
            placeholder: formValue.search_field ? '按' + keyworkList.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入关键字'
          };
        }
      }],
      list: [],
      listLoading: true,
      tableConfig: {},
      tableColumnConfig: [{
        label: '应用ID',
        prop: 'id',
        width: 70
      }, {
        label: '应用图标',
        prop: 'app_icon',
        width: 70,
        type: 'image',
        params: {
          preview: true
        }
      }, {
        label: '应用名称',
        prop: 'name'
      }, {
        label: '应用包名',
        width: 200,
        prop: 'package_name'
      }, {
        label: '应用描述',
        prop: 'app_desc'
      }, {
        label: '应用分类',
        width: 100,
        prop: 'custom_cat_name'
      }, {
        label: '语言',
        width: 100,
        prop: 'language'
      }, {
        label: '平台',
        width: 70,
        prop: 'platform'
      }, {
        label: '来源',
        width: 100,
        prop: 'source'
      }, {
        slot: 'action-cell'
      }],
      dialog: {
        config: {
          title: '更新应用信息',
          visible: false,
          loading: false
        },
        value: {
          id: '',
          name: '',
          package_name: '',
          icon_file: '',
          custom_cid: ''
        },
        itemList: [{
          label: '应用名称：',
          type: 'input',
          prop: 'name',
          rules: [{
            required: true,
            message: '请输入应用名称',
            trigger: 'blur'
          }]
        }, {
          label: '应用包名：',
          type: 'input',
          prop: 'package_name',
          rules: [{
            required: true,
            message: '请输入应用名称',
            trigger: 'blur'
          }]
        }, {
          label: '应用图标：',
          type: 'business',
          subtype: 'single-image-uploader',
          prop: 'icon_file',
          rules: [{
            required: true,
            message: '请选择上传应用图标',
            trigger: 'blur'
          }],
          params: {
            disabled: false,
            'with-credentials': true,
            class: 'upload-demo',
            'list-type': 'picture-card',
            accept: 'image/*',
            tip: '只能上传jpg/png文件',
            fileList: []
          }
        }, {
          label: '应用分类：',
          type: 'business',
          subtype: 'app-category-selector',
          prop: 'custom_cid',
          params: {
            disabled: false,
            clearable: true,
            placeholder: '请选择应用分类标签'
          },
          rules: [{
            required: true,
            message: '请选择应用分类标签',
            trigger: 'blur'
          }]
        }]
      }
    };
  },

  watch: {
    $route: function $route(to, from) {
      this.renderList(this.query);
    }
  },
  methods: {
    renderList: function renderList(params) {
      var _this = this;

      this.listLoading = true;
      fetchAppInfoList(params).then(function (res) {
        _this.listLoading = false;
        _this.list = _.get(res, 'data.data.list') || [];
        _this.pagination.total = _.get(res, 'data.data.total');
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    showUpdateDialog: function showUpdateDialog(appInfo) {
      var appIconItem = this.dialog.itemList.find(function (e) {
        return e.prop === 'icon_file';
      });
      this.dialog.config.visible = true;
      this.dialog.value = _extends({}, _.pick(appInfo, ['id', 'name', 'package_name']), {
        icon_file: appInfo.app_icon,
        custom_cid: appInfo.custom_cid || ''
      });
      if (appInfo.app_icon) {
        appIconItem.params.fileList = [{
          url: appInfo.app_icon,
          name: 'name'
        }];
      } else {
        appIconItem.params.fileList = [];
      }
    },
    submitDialogForm: function submitDialogForm() {
      var _this2 = this;

      this.dialog.config.loading = true;
      updateAppInfo(_.cloneDeep(this.dialog.value)).then(function () {
        _this2.dialog.config.loading = false;
        _this2.dialog.config.visible = false;
        _this2.renderList(_this2.query);
      }).catch(function () {
        _this2.dialog.config.loading = false;
      });
    },
    updateStoreAppInfo: function updateStoreAppInfo(appInfo) {
      var _this3 = this;

      this.listLoading = true;
      syncAppInfo({
        app_id: appInfo.id
      }).then(function () {
        _this3.$message({
          message: '更新成功',
          type: 'success'
        });
        _this3.renderList(_this3.query);
      }).catch(function () {
        _this3.listLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.renderList(this.query);
  }
};